import {apiRequest} from './util';

export function sendContactForm({name, email, phone, content}: {
    name: string,
    email: string,
    phone: string,
    content: string
}) {
    return apiRequest({
        path: '/ch/contact',
        method: "POST",
        data: {
            name,
            email,
            phone,
            content
        },
        ctx: undefined
    });
}
